import React, { useEffect, useRef, useState } from "react";
import "bootstrap-daterangepicker/daterangepicker.css";
import { useSelector, useDispatch, shallowEqual } from "react-redux";
import { getAllTokenTransactionAsync, TokenTransactionActions } from "../redux";
import {
  Card,
  CardHeader,
  CardHeaderToolbar,
} from "../../../../_metronic/_partials/controls";
import TokenTransactionTable from "./token_tnx_detail/TokenTxnTable";
import { Col, Row } from "react-bootstrap";
import Select from "react-select";
import DatePicker from "react-datepicker";
import { useLocation } from "react-router-dom";

export function TokenTransactions() {
  const [showAddTemplate, setShowAddTemplate] = useState(false);
  const [showEditTemplate, setShowEditTemplate] = useState(false);
  const dispatch = useDispatch();
  const searchTokenTransactionRef = useRef();
  const location = useLocation();
  const type = "EMAIL";
  const {
    refreshTokenList,
    search,
    searchText,
    fromDate,
    toDate,
  } = useSelector((state) => state.tokenTransaction, shallowEqual);

  // State for the selected filter values
  const [paymentStatus, setPaymentStatus] = useState("All");
  const [transactionType, setTransactionType] = useState("All");

  const paymentStatusOptions = [
    { value: "", label: "All" },
    { value: "PENDING", label: "Pending" },
    { value: "SUCCESS", label: "Success" },
    { value: "FAILED", label: "Failed" },
  ];

  const transactionTypeOptions = [
    { value: "", label: "All" },
    { value: "win", label: "Won Bet" },
    { value: "lost", label: "Created/Joined Bet" },
    { value: "void_bet", label: "Voided Bet" },
    { value: "cancel_bet", label: "Cancelled Bet" },
    { value: "credit", label: "Deposit" },
    { value: "debit", label: "Withdrawal" },
  ];

  // Handle URL parameters for username search
  useEffect(() => {
    const urlParams = new URLSearchParams(location.search);
    const username = urlParams.get("username");

    if (username) {
      // Set the search text with username
      dispatch(TokenTransactionActions.searchTextChange(username));
      // Trigger search
      dispatch(TokenTransactionActions.refreshTokenTransactionList());
    }
  }, [location.search, dispatch]);

  // Call API while filters or search text changes

  useEffect(() => {
    if (searchTokenTransactionRef.current) {
      let keyPressEvent = (e) => {
        if (e.keyCode === 13) {
          e.preventDefault();
          dispatch(TokenTransactionActions.refreshTokenTransactionList());
        }
      };
      let input = searchTokenTransactionRef.current;
      input.addEventListener("keyup", keyPressEvent);

      return () => {
        input.removeEventListener("keyup", keyPressEvent);
        dispatch(TokenTransactionActions.searchTextChange(""));
        input.value = "";
      };
    }
  }, []);

  useEffect(() => {
    if (refreshTokenList) {
      // Pass the selected filters to the API
      dispatch(
        getAllTokenTransactionAsync({
          search,
          searchText,
          fromDate,
          toDate,
        })
      );
    }
  }, [refreshTokenList]);

  const onAddClick = () => {
    setShowAddTemplate(true);
  };

  const onEditClick = (email) => {
    setShowEditTemplate(true);
  };

  const onSearchTextChange = (e) => {
    dispatch(TokenTransactionActions.searchTextChange(e.target.value));
  };

  const resetChanges = () => {
    setPaymentStatus("All");
    setTransactionType("All");
    dispatch(TokenTransactionActions.resetFilters());
  };

  const handleToDateChange = (date) => {
    const endOfDay = new Date(date);
    endOfDay.setHours(23, 59, 59, 999); // Set time to end of the day
    dispatch(TokenTransactionActions.toDateChanges(endOfDay));
  };
  const handleFromDateChange = (date) => {
    dispatch(TokenTransactionActions.fromDateChanges(date));
  };

  const onSelectChange = (key, setState) => (selectedOption) => {
    setState(selectedOption);

    dispatch(
      TokenTransactionActions.selectTextChange({
        [key]: selectedOption, // Update only the specific key
      })
    );
  };

  return (
    <>
      <Card>
        <Row>
          <Col>
            <Card>
              <CardHeader title="Token Transactions"></CardHeader>
            </Card>
          </Col>
        </Row>
        <div className="px-6 pt-0 dash_wt_bx pb-0 ovflhddn loader-display-position">
          <div className="px-6 pt-0 dash_wt_bx pb-0 ovflhddn loader-display-position">
            <Row>
              <Col>
                <CardHeaderToolbar>
                  <Row className="d-flex align-items-center justify-content-end gap-4">
                    <Col lg={2} className="p-0">
                      <div
                        style={{ margin: "1px" }}
                        className="date-picker-input"
                      >
                        <DatePicker
                          selected={fromDate}
                          autoComplete="off"
                          placeholderText="From date"
                          onChange={(date) => handleFromDateChange(date)}
                          name="fromDate"
                          value={fromDate}
                          maxDate={new Date()}
                          dateFormat="MMM d, yyyy"
                        />
                      </div>
                    </Col>
                    <Col lg={2} className="p-0">
                      <div
                        style={{ margin: "1px" }}
                        className="date-picker-input"
                      >
                        <DatePicker
                          name="toDate"
                          placeholderText="To date"
                          autoComplete="off"
                          value={toDate}
                          dateFormat="MMM d, yyyy"
                          selected={toDate}
                          maxDate={new Date()}
                          onChange={(date) => handleToDateChange(date)}
                        />
                      </div>
                    </Col>
                    <Col lg={1} className="p-0">
                      <button
                        className="btn_new btn-sm filter-btn w-100"
                        type="button"
                        onClick={() => resetChanges()}
                      >
                        Reset
                      </button>
                    </Col>

                    <Col lg={2} className="p-0">
                      <div className="viral-events-dropdown">
                        <Select
                          value={paymentStatus}
                          placeholder="Payment Status"
                          className="border-0 p-0 w-100"
                          classNamePrefix="phoSelect"
                          options={paymentStatusOptions}
                          onChange={onSelectChange("status", setPaymentStatus)}
                        />
                      </div>
                    </Col>
                    <Col lg={2} className="p-0">
                      <div className="viral-events-dropdown">
                        <Select
                          value={transactionType}
                          placeholder="Select Transaction Type"
                          className="border-0 p-0 w-100"
                          classNamePrefix="phoSelect"
                          options={transactionTypeOptions}
                          onChange={onSelectChange(
                            "transaction_type",
                            setTransactionType
                          )}
                        />
                      </div>
                    </Col>
                    <form
                      autoComplete="off"
                      className="subheader_filter"
                      onSubmit={(e) => e.preventDefault()}
                    >
                      <input
                        name="Search"
                        placeholder="Search. . ."
                        type="text"
                        className="form-control search-input"
                        value={searchText}
                        onChange={onSearchTextChange}
                        ref={searchTokenTransactionRef}
                      />
                    </form>
                  </Row>
                </CardHeaderToolbar>
              </Col>
            </Row>
          </div>
        </div>

        <TokenTransactionTable onEditClick={onEditClick} />
      </Card>
    </>
  );
}
